import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface BusinessStory {
  text: string;
  name: string;
  role: string;
  image: string;
  color: string;
}

@Component({
  selector: 'app-business-stories',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './business-stories.html',
  styleUrl: './business-stories.css',
})
export class BusinessStoriesComponent {
  readonly stories: BusinessStory[] = [
    {
      text: 'Admissions season used to mean stacks of paper forms and manual fee tracking. Now parents get instant fee receipts and our staff can see attendance and dues for every student on one screen.',
      name: 'Fahad Mehmood',
      role: 'Principal, Bright Future School',
      image: 'images/common/client11.png',
      color: '#8a63d2',
    },
    {
      text: 'Patient records, billing, and pharmacy stock used to live in three different registers. With orderYaa, our front desk and pharmacy work off the same system, so nothing gets lost between departments anymore.',
      name: 'Dr. Sana Khalid',
      role: 'Administrator, Al-Shifa Clinic',
      image: 'images/common/client8.png',
      color: '#eb5c6f',
    },
    {
      text: 'We supply to more than twenty retail outlets, and keeping track of who ordered what used to eat up half our week. orderYaa keeps procurement, delivery, and invoicing in sync so we ship faster and chase fewer payments.',
      name: 'Tahir Aslam',
      role: 'Owner, Aslam Distributors',
      image: 'images/common/client6.png',
      color: '#2fb380',
    },
  ];

  activeIndex = 0;

  select(index: number): void {
    this.activeIndex = index;
  }

  next(): void {
    this.activeIndex = (this.activeIndex + 1) % this.stories.length;
  }

  prev(): void {
    this.activeIndex = (this.activeIndex - 1 + this.stories.length) % this.stories.length;
  }
}
